import { render, staticRenderFns } from "./transcript-summary-item.vue?vue&type=template&id=dce3a7e8&scoped=true&"
import script from "./transcript-summary-item.vue?vue&type=script&lang=js&"
export * from "./transcript-summary-item.vue?vue&type=script&lang=js&"
import style0 from "./transcript-summary-item.vue?vue&type=style&index=0&id=dce3a7e8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce3a7e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce3a7e8')) {
      api.createRecord('dce3a7e8', component.options)
    } else {
      api.reload('dce3a7e8', component.options)
    }
    module.hot.accept("./transcript-summary-item.vue?vue&type=template&id=dce3a7e8&scoped=true&", function () {
      api.rerender('dce3a7e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-summary-item/transcript-summary-item.vue"
export default component.exports